/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Handle ajax 'Add To Cart' (ATC) forms
window.onSubmitAtcForm = async ($form, event) => {
    event.preventDefault()

    $form.classList.add('loading')

    const quantity = Number($form.querySelector('[name="quantity"]')?.value || 1)
    // This piece of code allow use the CART in application steps
    let subscriptionInputType
    if ($form.querySelector('input#quick-view-recharge-widget-type-subscription')) {
        subscriptionInputType = $form.querySelector('input#quick-view-recharge-widget-type-subscription')
    } else {
        subscriptionInputType = $form.querySelector('input#recharge-widget-type-subscription')
    }

    let response

    if (subscriptionInputType && subscriptionInputType.checked) {
        let id = Number($form.querySelector('[name="id"]').value)

        if ($form.querySelector('[name="id"]:checked')) {
            id = Number($form.querySelector('[name="id"]:checked').value)
        }

        const sellingPlan = $form.querySelector('[name="recharge-widget-schedule"]:checked').value

        const formData = {
            items: [{
                id: id,
                quantity: quantity,
                selling_plan: sellingPlan
            }]
        }

        response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
         
        })
    } else {
        const parent = $form.closest('.product-container')

        if (parent) {
            let variantId = $form.querySelector('[name="id"]').value;
            const container = parent.querySelector('.list-buttons')

            if (container) {
                const inputChecked = container.querySelector('input:checked')
                variantId = inputChecked.value
            }

            const formData = {
                items: [{
                    id: variantId,
                    quantity: 1
                  
                }]
            }

            response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            })

        } else {
            response = await fetch('/cart/add.js', { method: 'POST', body: new FormData($form) })
        }
    }

    const product = await response.json()

    if (!response.ok) {
        setTimeout(() => {
            document.querySelector('#offcanvas-cart').querySelector('.offcanvas-body').insertAdjacentHTML('afterbegin', `
                <p 
                    class="alert alert-warning small mx-4"
                    style="border-radius: 0; line-height: normal;">
                    Something went wrong! The product might be out of stock. Please try again later. If the issue persist please <a href="/pages/contact">contact us</a>
                </p>
            `)
        }, 1500)
    }

    $form.classList.remove('loading')
    const btnATC = $form.querySelector(".btn-atc")
    let btnATCText
    if (btnATC) {
        btnATCText = btnATC.textContent

        btnATC.innerHTML = `<span>Added</span><svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                <path d="M18.4425 6.06754L8.44254 16.0675C8.38449 16.1256 8.31556 16.1717 8.23969 16.2032C8.16381 16.2347 8.08248 16.2508 8.00035 16.2508C7.91821 16.2508 7.83688 16.2347 7.76101 16.2032C7.68514 16.1717 7.61621 16.1256 7.55816 16.0675L3.18316 11.6925C3.06588 11.5753 3 11.4162 3 11.2503C3 11.0845 3.06588 10.9254 3.18316 10.8082C3.30044 10.6909 3.4595 10.625 3.62535 10.625C3.7912 10.625 3.95026 10.6909 4.06753 10.8082L8.00035 14.7418L17.5582 5.18316C17.6754 5.06588 17.8345 5 18.0003 5C18.1662 5 18.3253 5.06588 18.4425 5.18316C18.5598 5.30044 18.6257 5.4595 18.6257 5.62535C18.6257 5.7912 18.5598 5.95026 18.4425 6.06754Z" fill="black"/>
                            </svg>`

        setTimeout(function () {
            btnATC.textContent = btnATCText;
        }, 3000);
    }


    if ($form.classList.contains('informATC')) {
        console.log('added to cart')
        $form.querySelector("button > span").innerText = "Added to Bag"
    }

    if (response.ok) {
        ttq.track('AddToCart', {
            content_type: 'product',
            content_id: product.handle,
            content_name: product.title,
            quantity: quantity,
            price: product.price / 100,
            value: product.price / 100 * quantity,
            currency: Shopify.currency.active
        })
        gtag('event', 'conversion', {
            'send_to': 'AW-444641639/Jut-CPCcj_IBEOfigtQB',
            'value': product.price / 100 * quantity,
            'currency': Shopify.currency.active
        });
    }
}

window.onSubmitAllAtcForm = async (e) => {
    let buttonAll;
    let buttonAllMobile;
    let inputsProducts;

    if (e) {
        buttonAll = document.querySelector(`${e.dataset.sectionId} #icon-button-all`);
        buttonAllMobile = document.querySelector(`${e.dataset.sectionId} #icon-button-all-mobile`);
        inputsProducts = document.querySelectorAll(`${e.dataset.sectionId} .input-product`);
    }
    else {
        buttonAll = document.getElementById("icon-button-all");
        buttonAllMobile = document.getElementById("icon-button-all-mobile");
        inputsProducts = document.querySelectorAll('.input-product');
    }

    const items = [];
    const quantity = 1;
    let response;

    if (buttonAll)
        buttonAll.classList.remove("d-none");
    if (buttonAllMobile)
        buttonAllMobile.classList.remove("d-none");

    inputsProducts.forEach(function (input) {
        items.push({ id: input.value, quantity: 1 });
    });

    if (items.length) {
        response = await fetch('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }), headers: { "Content-Type": "application/json", }, })

        const products = await response.json()

        if (!response.ok) {
            setTimeout(() => {
                document.querySelector('#offcanvas-cart').querySelector('.offcanvas-body').insertAdjacentHTML('afterbegin', `
                    <p 
                        class="alert alert-warning small mx-4"
                        style="border-radius: 0; line-height: normal;">
                        Something went wrong! The product might be out of stock. Please try again later. If the issue persist please <a href="/pages/contact">contact us</a>
                    </p>
                `)
            }, 1500)
        }

        if (buttonAll)
            buttonAll.classList.add("d-none");
        if (buttonAllMobile)
            buttonAllMobile.classList.add("d-none");


        if (response.ok) {
            products.items.forEach(function (product) {
                ttq.track('AddToCart', {
                    content_type: 'product',
                    content_id: product.handle,
                    content_name: product.title,
                    quantity: quantity,
                    price: product.price / 100,
                    value: product.price / 100 * quantity,
                    currency: Shopify.currency.active
                })
                gtag('event', 'conversion', {
                    'send_to': 'AW-444641639/Jut-CPCcj_IBEOfigtQB',
                    'value': product.price / 100 * quantity,
                    'currency': Shopify.currency.active
                });
            });
        }
    }
}

window.onSubmitAtcSubsForm = async ($form, event) => {
    event.preventDefault()
    let id = Number($form.querySelector('[name="id"]').value)
    let sellingPlan = $form.querySelector('[name="subscription"]').value
    let quantity = 1;

    const formData = {
        items: [{
            id: id,
            quantity,
            selling_plan: sellingPlan
        }]
    }
    let response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })

    const product = await response.json()

    if (response.ok) {
        ttq.track('AddToCart', {
            content_type: 'product',
            content_id: product.handle,
            content_name: product.title,
            quantity,
            price: product.price / 100,
            value: product.price / 100 * quantity,
            currency: Shopify.currency.active
        })
        gtag('event', 'conversion', {
            'send_to': 'AW-444641639/Jut-CPCcj_IBEOfigtQB',
            'value': product.price / 100 * quantity,
            'currency': Shopify.currency.active
        });
    }

}